"use client";

import React from "react";
import { Map, Marker } from "@vis.gl/react-google-maps";
import { LuArrowUpRight } from "react-icons/lu";

import { Button } from "~/components/v3/themed/Button";
import { GetEventFromSlug } from "../actions";
import { CustomizableLayout } from "~/types/CustomizableLayout";
import { cn } from "~/utils/fontsConfig";

export const MapLocation = ({
    event,
    customization,
}: {
    event: GetEventFromSlug;
    customization?: CustomizableLayout;
}) => {
    if (
        !event.useGoogleMapsLocation ||
        event.protectedFields?.find((field) => field.name === "map")
    ) {
        return null;
    }

    const position = {
        lat: event.latitude ?? 0,
        lng: event.longitude ?? 0,
    };

    const handleOpenGoogleMaps = () => {
        if (event.googleMapsPlaceId && event.googleMapsPlaceName) {
            const url = `https://www.google.com/maps/search/?api=1&query=${event.googleMapsPlaceName}&query_place_id=${event.googleMapsPlaceId}`;
            window.open(url, "_blank", "noopener,noreferrer");
            return;
        }

        const url = `https://www.google.com/maps/search/?api=1&query=${position.lat},${position.lng}`;
        window.open(url, "_blank", "noopener,noreferrer");
    };

    return (
        <div className="flex flex-col gap-4">
            <div className="h-[150px] w-full overflow-hidden rounded-lg">
                <Map zoom={15} center={position} gestureHandling="auto">
                    <Marker
                        position={position}
                        title={event.googleMapsPlaceName ?? ""}
                        {...(event.googleMapsPlaceId && {
                            placeId: event.googleMapsPlaceId,
                            title: event.googleMapsPlaceName ?? "",
                        })}
                    />
                </Map>
            </div>

            <Button
                variant="default"
                size="xs"
                className={cn(
                    "rounded-lg bg-white/15 p-3 text-xs text-white",
                    customization?.linkClassName,
                )}
                onClick={handleOpenGoogleMaps}
            >
                <span>See on Google Maps</span>
                <LuArrowUpRight className="h-3 w-3" size={20} />
            </Button>
        </div>
    );
};
